import React, { useState } from "react"
import {
  EmployeeBar,
  InnerContainer,
  LeftInnerContainer,
  RightInnerContainer,
  NavWrapper,
} from "./EmployeeNavigation.styles"
import Icon from "../Icon/Icon"
import styled from "styled-components"
import { Link } from "gatsby"
import Navigation from "../Navigation/Navigation"
import { useMenuQuery } from "../../hooks/useMenuQuery"

const EmployeeNavigation = ({ userInfo }) => {
  let i = 0

  const NavContent = styled.div`
    height: 50px;
    width: 100%;
    margin: 0 auto;

    background: var(--illiniDarkBlue);
    nav ul li a {
      color: var(--white);
      background: var(--illiniDarkBlue);
    }
    nav ul li a:hover {
      color: var(--illiniOrange);
    }
    nav ul ul {
      background: var(--illiniDarkBlue);
    }

    nav .nav-active {
      color: var(--illiniDarkBlue);
    }

    nav ul li a ul {
      background: var(--illiniDarkBlue);
    }

    nav ul li a ul li a {
      color: var(--white);
      background: var(--illiniDarkBlue);
    }

    nav ul li a ul li a:hover {
      color: var(--illiniOrange);
    }

    button {
      background: var(--illiniDarkBlue);
      color: var(--white);
    }

    @media (max-width: 991px) {
      display: none;
    }
  `

  const employeeMenuData = useMenuQuery()

  let menu = [
    {
      id: 1,
      label: "Employee Menu",
      url: "#",
      childItems: {
        nodes: [
          {
            id: 4,
            label: "ERIN",
            url: "/Employee/Home",
            parentId: 1,
            childItems: {
              nodes: [],
            },
          },
          {
            id: 5,
            label: "Main Website",
            url: "/",
            parentId: 1,
            childItems: {
              nodes: [],
            },
          },
          {
            id: 6,
            label: "Logout",
            url: "/logout",
            parentId: 1,
            childItems: {
              nodes: [],
            },
          },
        ],
      },
    },
  ]

  function removeClass(className) {
    const elements = document.querySelectorAll(`.${className}`)

    elements.forEach(element => {
      element.classList.remove(className)
    })
  }

  function ClickHandler(mainItem, i) {
    const [click, setClick] = useState(false)
    const handleClick = () => {
      removeClass("active")
      removeClass("nav-active")

      setClick(!click)
    }

    function keydown(event) {
      if (event.keyCode === 13) {
        removeClass("active")
        removeClass("nav-active")
        setClick(!click)
      }
    }

    return (
      // build menu item and child menu
      <li key={mainItem.id}>
        <a
          key={mainItem.id}
          href={mainItem.url}
          onClick={handleClick}
          onKeyDown={keydown}
          tabIndex={i}
          className={click ? "nav nav-active" : "nav"}
        >
          {mainItem.label}
          {mainItem.childItems.nodes.length > 0 ? (
            <>
              {mainItem.childItems.nodes.length !== 0 && click ? (
                <div>
                  <Icon className="icon" category="Up Arrow" />
                </div>
              ) : (
                <div>
                  <Icon className="icon" category="Down Arrow" />
                </div>
              )}

              {mainItem.childItems.nodes.length > 0 ? (
                <ul className={click ? "active" : ""}>
                  {mainItem.childItems.nodes.map(childItem => {
                    return (
                      <li key={childItem.id}>
                        {childItem.url.charAt(0) === "/" ? (
                          <Link
                            to={childItem.url}
                            activeClassName="nav-active"
                            className="secondaryLink"
                          >
                            {childItem.label}
                          </Link>
                        ) : (
                          <a href={childItem.url} className="secondaryLink">
                            {childItem.label}
                          </a>
                        )}
                      </li>
                    )
                  })}
                </ul>
              ) : null}
            </>
          ) : null}
        </a>
      </li>
    )
  }

  return (
    <>
      <EmployeeBar>
        <InnerContainer>
          <LeftInnerContainer>
            <NavContent>
              <Navigation
                menu={employeeMenuData.employeeMenu.menuItems.nodes}
              />
            </NavContent>
          </LeftInnerContainer>
          <RightInnerContainer>
            <div className="user-info">
              <span className="user-name">
                Welcome {userInfo?.userDetails || "Guest"}
              </span>
              <NavWrapper>
                <ul>
                  {menu.map(mainItem =>
                    !mainItem.parentId // necessary for each component to get it's own clickhandler
                      ? ClickHandler(mainItem, i)
                      : null
                  )}
                </ul>
              </NavWrapper>
            </div>
          </RightInnerContainer>
        </InnerContainer>
      </EmployeeBar>
    </>
  )
}

export default EmployeeNavigation
